var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonthlyBillingThumb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M81.3 53.7C81.1 48.2 80.5 31.9 63 27.6C54.8 25.6 47 26 40.3 28.6C38.2 24.3 32.3 21.6 32.3 21.6C21 25.8 19.6 33.7 19.6 33.7C22 34.7 25.6 37.1 28.1 37C26.3 39 24.6 41.2 23.1 43.7C21.7 45.8 19.3 49.8 16.5 49.9C15.2 49.9 11.6 49.4 9.79998 49.3C8.19998 49.1 7.79998 50.7 7.79998 51.1C7.69998 53.2 7.69998 62 7.99998 64.6C9.19998 69.8 16.3 72.5 25.3 75.8C25.6 77.1 26.1 80.9 26.6 82.6C26.7 82.8 26.7 83 26.8 83.2C27 83.4 27.3 83.4 27.6 83.4C29.6 83.4 31.1 83.4 33.1 83.3C33.3 83.3 33.6 83.3 33.8 83.1C34.1 82.9 34.1 82.6 34.2 82.3C34.3 81.8 34.5 79.1 34.6 78.5C46 81 58.1 81.1 65.1 77.1C65.2 78 65.5 81.1 65.8 82.3C65.8 82.4 66.1 82.9 66.7 82.9C67.8 82.9 70.5 82.9 71.7 82.9C71.9 82.9 72.4 82.8 72.7 82.1C76.5 75.1 81.6 64 81.3 53.7Z",
    fill: "#FF989A",
    stroke: "#FF989A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4 45.4C31.4 45.4 36.7 41.9 40.4 48.9",
    stroke: "#101C1E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3 49.6C75.3 49.6 82.4 50.2 86.6 44C89.9 39.1 87.4 35.4 85 36.6C83.4 37.4 83.2 40.5 83.5 42C84.3 45.6 92.2 49.4 92.2 49.4",
    stroke: "#FF989A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59 38.9C65.1856 38.9 70.2 33.8856 70.2 27.7C70.2 21.5144 65.1856 16.5 59 16.5C52.8144 16.5 47.8 21.5144 47.8 27.7C47.8 33.8856 52.8144 38.9 59 38.9Z",
    fill: "#FEDC5D",
    stroke: "#FEDC5D",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8 21.7L60.9 28.1C60.7 28.5 60.5 29 60.2 29.3C59.9 29.7 59.6 30 59.3 30.2C58.9 30.4 58.5 30.5 58 30.5C57.5 30.5 56.9 30.4 56.3 30.1C55.5 29.8 55 29.3 54.6 28.7C54.2 28.1 54.2 27.4 54.4 26.5",
    stroke: "#00A997",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7 50.7C70.5 43.8 64.8 36.3 56 34C47.2 31.7 38.6 35.5 36.8 42.4L68.7 50.7Z",
    fill: "#FF989A",
    stroke: "#FF989A",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlyBillingThumb);
export default __webpack_public_path__ + "static/media/monthly-billing-thumb.f3f7c42275dc9d597b6d167386d9083c.svg";
export { ForwardRef as ReactComponent };